<table class="ir-plugin-table optimisation-equipment" *ngIf="machine && machine.length">
  <tbody style="vertical-align: top">
    <tr class="th-plugin-line--subheader">
      <td width="25%">
        <span
          ><strong>{{ 'plugins.installation-equipment-info.product-line' | translate }}</strong></span
        >
      </td>
      <td width="25%">
        <span
          ><strong>{{ 'plugins.installation-equipment-info.equipment-type' | translate }}</strong></span
        >
      </td>
      <td width="25%">
        <span
          ><strong>{{ 'plugins.installation-equipment-info.serial-number' | translate }}</strong></span
        >
      </td>
      <td width="25%">
        <span
          ><strong>{{ 'plugins.installation-equipment-info.supplier' | translate }}</strong></span
        >
      </td>
    </tr>
    <tr class="th-plugin-line--content" *ngFor="let m of machine">
      <td width="25%">
        <span>{{ m?.ProductLine | productline | async }}</span>
      </td>
      <td width="25%">
        <span>{{ m?.name }}</span>
      </td>
      <td width="25%">
        <span>{{ m?.SerialNumber }}</span>
      </td>
      <td width="25%">
        <span>{{ m?.Supplier | supplier }}</span>
      </td>
    </tr>
  </tbody>
</table>
